import { AbstractControl, ValidationErrors } from '@angular/forms';

export function quantityValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (value === null || value === undefined || isNaN(value)) return null;

  const parsedValue = Number(value);
  if (parsedValue <= 0 || parsedValue > 100) {
    return { invalidQuantity: true };
  }
  return null;
}

export function discountValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (value === null || value === undefined || isNaN(value)) return null;

  const parsedValue = Number(value);
  if (parsedValue <= 0 || parsedValue > 100) {
    return { invalidDiscount: true };
  }
  return null;
}
